import { render } from "./AuthorCredentials.vue?vue&type=template&id=32d053d3"
import script from "./AuthorCredentials.vue?vue&type=script&lang=js"
export * from "./AuthorCredentials.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__